import { atom } from 'jotai'

/**
 * Bridges the in-chat runbook plan card (`ProposeRunbookMessage`, rendered deep
 * in the chat tree) to the `/runbooks/new` drafting page that owns persistence.
 *
 * `proposeRunbook` no longer auto-persists — it produces an ephemeral PLAN the
 * user reviews in chat and explicitly builds. The drafting page records the
 * latest plan's `toolCallId` here so the card shows its "Build runbook" button
 * only for the most recent refinement turn (superseded plans don't offer a
 * stale build), and reflects the in-flight build via `building`.
 */
export type BuildableRunbookPlan = {
  /** `toolCallId` of the latest buildable `proposeRunbook` plan, or null. */
  callId: string | null
  /** True while the page is persisting the plan into a draft runbook. */
  building: boolean
}

export const buildableRunbookPlanAtom = atom<BuildableRunbookPlan>({
  callId: null,
  building: false,
})
